/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RespondToInviteBody
 */
export interface RespondToInviteBody {
    /**
     * 
     * @type {boolean}
     * @memberof RespondToInviteBody
     */
    accept: boolean;
    /**
     * Your in-game name (2-32 characters) — required when accepting; snapshot to your roster entry for score verification
     * @type {string}
     * @memberof RespondToInviteBody
     */
    playerName?: string;
}

/**
 * Check if a given object implements the RespondToInviteBody interface.
 */
export function instanceOfRespondToInviteBody(value: object): value is RespondToInviteBody {
    if (!('accept' in value) || value['accept'] === undefined) return false;
    return true;
}

export function RespondToInviteBodyFromJSON(json: any): RespondToInviteBody {
    return RespondToInviteBodyFromJSONTyped(json, false);
}

export function RespondToInviteBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RespondToInviteBody {
    if (json == null) {
        return json;
    }
    return {
        
        'accept': json['accept'],
        'playerName': json['playerName'] == null ? undefined : json['playerName'],
    };
}

export function RespondToInviteBodyToJSON(json: any): RespondToInviteBody {
    return RespondToInviteBodyToJSONTyped(json, false);
}

export function RespondToInviteBodyToJSONTyped(value?: RespondToInviteBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accept': value['accept'],
        'playerName': value['playerName'],
    };
}

